<template>
  <div class="order" v-loading="loading" :element-loading-text="loadingText">
    <appheader index="2"></appheader>
    <Search @searchOrder="searchOrder" :CommodityArr="CommodityArr" />
    <div class="orderContent">
      <div>
        <el-table
          :data="orderList"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          class="tableData"
          style="width: 100%"
        >
          <el-table-column property="orderNo" label="采购单号">
            <template slot-scope="scope">
              <span class="font-color" @click="viewOrderDetails(scope.row)">{{ scope.row.orderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column property="netCode" label="网点编码"></el-table-column>
          <el-table-column property="netAddress" label="网点名称"></el-table-column>
          <el-table-column property="totalQuantity" label="件数合计"></el-table-column>
          <el-table-column property="totalGoldWeight">
            <template slot="header">
              <span class="header-with-tip">
                <span>金重合计</span>
                <el-popover placement="top" title="" width="200" trigger="hover" content="注：预估金重，实际金重以结算为准">
                  <span slot="reference">
                    <svg-icon iconClass="question-mark" class="question-mark"></svg-icon>
                  </span>
                </el-popover>
              </span>
            </template>
          </el-table-column>
          <el-table-column property="createdTime" label="下单日期"></el-table-column>
          <el-table-column property="payerName" label="下单人"></el-table-column>
          <el-table-column property="payerContact" label="联系电话"></el-table-column>
          <el-table-column property="remark" label="订单备注"></el-table-column>
          <el-table-column property="" label="订单状态">
            <template slot-scope="scope">
              <span>{{ getOrderStatusText(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="listQuery.approvalStatus == '3' || !listQuery.approvalStatus"
            property="oaPushError"
            label="失败原因"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column property="totalWeight" label="操作" width="220">
            <template slot-scope="scope">
              <!-- <el-button v-if="scope.row.approvalStatus == 4" type="text" class="review-btn" @click="directlyRepush(scope.row, '推送')">
                推送
              </el-button> -->
              <el-button
                v-if="showRepushActions(scope.row)"
                type="text"
                class="review-btn"
                @click="directlyRepush(scope.row, '重推')"
              >
                重推
              </el-button>
              <el-button
                v-if="showRepushActions(scope.row)"
                type="text"
                class="review-btn"
                @click="cancelOrder(scope.row)"
              >
                取消
              </el-button>
              <el-button v-if="showDeleteAction(scope.row)" type="text" class="review-btn" @click="deleteOrder(scope.row)"> 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="box_fenye" v-if="orderNoListFlag">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="listQuery.current"
            :page-sizes="[10, 20, 40, 60, 100]"
            :page-size="listQuery.size"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <bottom></bottom>
    <PlainGoldetails
      v-if="plainGoldDialogVisible"
      :key="currentOrderNo"
      :plainGoldDialogVisible="plainGoldDialogVisible"
      :orderNo="currentOrderNo"
      :orderSummary="currentOrderSummary"
      @onCloseSelectDialog="onCloseSelectDialog"
    />
  </div>
</template>

<script>
import Appheader from '../moudel/Appheader';
import bottom from '../bady_bottom/bottom';
import Search from './components/Search.vue';
import PlainGoldetails from './components/PlainGoldetails.vue';
import { getReviewOrderList, getReviewCountBystatus, orderDirectlyRepush, orderDelete, cancelOrder as cancelOrderApi } from '@/api/orderApi';
import { reviewOrderTypeFilter } from '@/utils/filetrs';

export default {
  name: 'Order',
  components: {
    Appheader,
    bottom,
    Search,
    PlainGoldetails,
  },
  data() {
    return {
      orderNoListFlag: true,
      plainGoldDialogVisible: false,
      currentOrderNo: '',
      currentOrderSummary: {},
      CommodityArr: [
        {
          title: '全部',
          status: '',
          badge: '',
        },
        {
          title: '推送中',
          status: '4',
          badge: '',
        },
        {
          title: 'OA发起失败',
          status: '3',
          badge: '',
        },
        {
          title: 'OA审批中',
          status: '0',
          badge: '',
        },
        {
          title: 'OA审批通过',
          status: '1',
          badge: '',
        },
        {
          title: 'OA审批不通过',
          status: '2',
          badge: '',
        },
        {
          title: '已取消',
          status: '8',
          badge: '',
        },
      ],
      listQuery: {
        size: 10,
        current: 1,
        styleNumber: '',
        orderNo: '',
        netAddress: '',
        netCode: '',
        approvalStatus: '',
        orderStatus: '',
      },
      orderList: [],
      total: 0,
      loading: false,
      loadingText: '正在加载订单',
    };
  },
  filters: {
    reviewOrderTypeFilter,
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    showRepushActions(row) {
      return row.orderStatus != 8 && (row.approvalStatus == 3 || row.approvalStatus == 2);
    },
    showDeleteAction(row) {
      return row.orderStatus == 8;
    },
    getOrderStatusText(row) {
      return row.orderStatus == 8 ? '已取消' : reviewOrderTypeFilter(row.approvalStatus);
    },
    viewOrderDetails(row) {
      this.currentOrderNo = row.orderNo || '';
      this.currentOrderSummary = { ...row };
      this.plainGoldDialogVisible = true;
    },
    directlyRepush(row, text) {
      this.$confirm(`确定${text}oa审批？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.loading = true;
          this.loadingText = `正在${text}订单`;
          return orderDirectlyRepush(row);
        })
        .then(() => {
          this.$message({
            message: `${text}成功!`,
            type: 'success',
            duration: 1500,
          });
          this.loadingText = '正在加载订单';
          return this.getOrderList(false);
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
          this.loadingText = '正在加载订单';
        });
    },
    cancelOrder(row) {
      const params = {
        orderNo: row.orderNo,
      };
      this.$confirm('确定取消订单嘛？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.loading = true;
          this.loadingText = '正在取消订单';
          return cancelOrderApi(params);
        })
        .then(() => {
          this.$message({
            message: '取消成功!',
            type: 'success',
            duration: 1500,
          });
          this.loadingText = '正在加载订单';
          return this.getOrderList(false);
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
          this.loadingText = '正在加载订单';
        });
    },
    deleteOrder(row) {
      this.$confirm('确定删除订单嘛？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.loading = true;
          this.loadingText = '正在删除订单';
          return orderDelete(row);
        })
        .then(() => {
          this.$message({
            message: '删除成功!',
            type: 'success',
            duration: 1500,
          });
          this.loadingText = '正在加载订单';
          return this.getOrderList(false);
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
          this.loadingText = '正在加载订单';
        });
    },
    onCloseSelectDialog() {
      this.plainGoldDialogVisible = false;
      this.currentOrderNo = '';
      this.currentOrderSummary = {};
    },
    fetchList() {
      return this.getOrderList();
      // this.getCustomerCode();
    },
    searchOrder(searchCondition, status) {
      const isCanceledStatus = status === '8';
      this.listQuery = {
        ...this.listQuery,
        ...searchCondition,
        current: 1,
        approvalStatus: isCanceledStatus ? '' : status,
        orderStatus: isCanceledStatus ? '8' : '',
      };
      this.getOrderList();
    },
    getCustomerCode() {
      getReviewCountBystatus().then((res) => {
        const badgeMap = res.data || {};
        const hasBadge = Object.keys(badgeMap).length > 0;

        this.CommodityArr.forEach((item) => {
          item.badge = hasBadge && item.status !== '7' && item.status !== '8' ? badgeMap[item.status] || '' : '';
        });
      });
    },
    getOrderList(withLoading = true) {
      if (withLoading) {
        this.loading = true;
        this.loadingText = '正在加载订单';
      }

      return getReviewOrderList(this.listQuery, 1)
        .then((res) => {
          if (res.code !== 0) return;

          const { records = [], total = 0 } = res.data || {};
          this.orderList = records;
          this.total = total;
          this.orderNoListFlag = total > 0;
        })
        .finally(() => {
          if (withLoading) {
            this.loading = false;
            this.loadingText = '正在加载订单';
          }
        });
    },
    handleSizeChange(val) {
      this.listQuery.size = val;
      this.getOrderList();
    },
    handleCurrentChange(val) {
      this.listQuery.current = val;
      this.getOrderList();
    },
  },
};
</script>

<style scoped lang="scss">
.order {
  .orderContent {
    max-width: 1500px;
    margin: 0 auto;
    min-height: 700px;
  }
}

.tableData :empty::before {
  content: '-';
}

.font-color {
  color: #ec9368;
  cursor: pointer;
}

.header-with-tip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.question-mark {
  width: 16px;
  height: 16px;
  margin-left: 3px;
  cursor: pointer;
}
</style>

<style>
.box_fenye {
  max-width: 1500px;
  width: 100%;
  margin: 68px auto 0;
  text-align: center;
  position: relative;
}

.box_fenye .el-pagination__total {
  line-height: 42px !important;
  color: #ec9368;
  font-size: 16px !important;
}

.box_fenye .el-pagination__jump {
  color: #ec9368;
  font-size: 16px;
}

.box_fenye .el-pagination__jump .el-input__inner {
  height: 42px !important;
  width: 40px;
}

.box_fenye .el-input__inner {
  width: 102px;
  height: 42px !important;
  border: 1px solid #cdcdcd;
  color: #ec9368;
  font-size: 16px !important;
}

.box_fenye .btn-next i::before,
.box_fenye .btn-prev i::before {
  color: #ec9368;
  font-size: 16px;
  line-height: 42px;
}

.box_fenye .active {
  color: #fff !important;
  background-color: #ec9368;
}

.box_fenye .el-pager li {
  color: #ec9368;
  width: 42px;
  height: 42px;
  line-height: 42px;
  font-size: 16px;
}

.box_fenye .el-pager li:hover {
  color: #fff;
  background-color: #ec9368;
}

.box_fenye .number {
  border: 1px solid #cdcdcd;
  margin: 0 2px;
}

.review-btn,
.review-btn:hover,
.review-btn:focus {
  width: auto;
  color: #ec9368;
}
</style>
